export default __webpack_public_path__ + "static/media/medium.e1acb97a.svg";